// src/constants/endpoints.js

// user
export const USER_ENDPOINTS = {
  USER: '/api/v1/user/',
  USER_REQUEST: '/api/v1/user/user-request',
}

// manager
export const MANAGER_ENDPOINTS = {
  MANAGER: '/api/v1/manager/',
  MANAGER_STORE: '/api/v1/manager/store',
  MANAGER_JRS: '/api/v1/manager/jrs/',
  MANAGER_STORE_JRSLIST: '/api/v1/manager/jrs/store/',
  MANAGER_PROMOTION: '/api/v1/manager/promotion',
  MANAGER_PROMOTION_PRODUCT: '/api/v1/manager/promotion/product',
  MANAGER_OVERVIEW: '/api/v1/manager/overview',
  MANAGER_PAGED_AD_PRODUCT: '/api/v1/manager/ad/paged-ad-products',
  MANAGER_PAGED_AD_ORDER: '/api/v1/manager/ad/paged-ad-orders',
  MANAGER_AD_ORDER: '/api/v1/manager/ad/order/',
  MANAGER_PAGED_STORE_ORDER: '/api/v1/manager/order/paged-user-orders',
  USER_ORDER_CANCEL: '/api/v1/manager/order/cancel-order/',
  AD_ORDER_CANCEL: '/api/v1/manager/ad/cancel-order/',
}

// admin
export const ADMIN_ENDPOINTS = {
  PAGED_USERS: '/api/v1/admin/user/paged-users',
  UPDATE_USER: '/api/v1/admin/user/update-user',
  PAGED_AD_ORDER: '/api/v1/admin/ad/paged-ad-orders',
  UPDATE_ORDER: '/api/v1/admin/update-order',
  // CANCEL_ORDERS: '/api/v1/admin/ad/cancel-order',
  CANCEL_AD_ORDER: '/api/v1/admin/ad/cancel-order',
  PAGED_FAQS: '/api/v1/admin/paged-faqs',
  DELETED_FAQ: '/api/v1/admin/faq',
  UPDATE_FAQ: '/api/v1/admin/faq',
  PAGED_NOTICES: '/api/v1/admin/paged-notices',
  DELETED_NOTICE: '/api/v1/admin/notice',
  UPDATE_NOTICE: '/api/v1/admin/notice',
  MIGRATED_JRS: '/api/v1/admin/migration/jrs',
  BATCH_MIGRATE_JRS: '/api/v1/admin/migration/jrs/batch',
  PAGED_JRSLIST: '/api/v1/admin/paged-jrs',
  SEND_SCRAPING: '/api/v1/admin/naverPlaceScrap',
  GET_ADDRESS: '/api/v1/admin/scraped-areas',
}

// store
export const STORE_ENDPOINTS = {
  STORE: '/api/v1/store/',
  PAGED_STORES: '/api/v1/store/paged-stores',
  STORE_ORDER: '/api/v1/store/order',
  STORE_PAY: '/api/v1/store/payment',
}

// jrs
export const JRS_ENDPOINTS = {
  JRS: '/api/v1/jrs/',
}

// promotion
export const PROMOTION_ENDPOINTS = {
  PROMOTION: '/api/v1/promotion',
  PAGED_PROMOTIONS: '/api/v1/promotion/paged-promotions',
  PROMOTION_ORDER: '/api/v1/promotion/order',
  PROMOTION_PAY: '/api/v1/promotion/payment',
}

// file
export const FILE_ENDPOINTS = {
  FILE: '/api/v1/file',
  GET_MULTIPLE_FILES: '/api/v1/file/get-multiple-files',
}

// auth
export const AUTH_ENDPOINTS = {
  SIGN_IN: '/api/v1/auth/sign-in',
  CONFIRM_SIGN_IN: '/api/v1/auth/confirm-sign-in',
  REFRESH_TOKEN: '/api/v1/auth/token',
  UPDATE_USER: '/api/v1/auth/update-user-attribute',
  SIGN_IN_SNS: '/api/v1/auth/sign-in/sns',
}

export const ORDER_ENDPOINTS = {
  ORDER: '/api/v1/order/',
  AD_ORDER: '/api/v1/ad/order/',
  AD_PAYMENT: '/api/v1/ad/payment/',
  PAGED_ORDERS: '/api/v1/manager/ad/paged-ad-orders',
}
